module.exports = __webpack_public_path__ + "static/media/caret-down.bc66b62e.svg";